import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from 'services/api';
import { logout } from './userSlice';

export const initialState = {
  languageRequests: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

export const languageRequestSlice = createSlice({
  name: 'languageRequest',
  initialState: initialState,
  reducers: {
    setLanguageRequests: (state, { payload }) => {
      state.languageRequests = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

export const fetchAllLanguageRequests = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchAllLanguageRequests(page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setLanguageRequests(result.data.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
    }
  } catch (error) {
    console.log('error', error);
  }
  !disableLoader && dispatch(setLoader(false));
};
export const fetchLanguageRequests = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchLanguageRequests(page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setLanguageRequests(result.data.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
    }
  } catch (error) {
    console.log('error', error);
  }
  !disableLoader && dispatch(setLoader(false));
};

export const addLanguageRequest = (data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.addLanguageRequest(data);
    if (result.status >= 200 && result.status < 300) {
      callback && callback(true, result.data.message, result.data.data);
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
      callback && callback(false, result.data.message || 'Validation error');
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
      callback && callback(false, 'Unauthorized');
    } else {
      callback && callback(false, result?.data?.message || 'Error');
    }
  } catch (error) {
    console.log('error', error);
    callback && callback(false, 'Error');
  }
  dispatch(setLoader(false));
};

export const updateLanguageRequest = (id, data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.updateLanguageRequest(id, data);
    if (result.status >= 200 && result.status < 300) {
      callback && callback(true, result.data.message, result.data.data);
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
      callback && callback(false, result.data.message || 'Validation error');
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
      callback && callback(false, 'Unauthorized');
    } else {
      callback && callback(false, result?.data?.message || 'Error');
    }
  } catch (error) {
    console.log('error', error);
    callback && callback(false, 'Error');
  }
  dispatch(setLoader(false));
};

export const approveLanguageRequest = (id, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.approveLanguageRequest(id);
    if (result.status >= 200 && result.status < 300) {
      callback && callback(true, result.data.message, result.data.data);
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
      callback && callback(false, result.data.message || 'Validation error');
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
      callback && callback(false, 'Unauthorized');
    } else {
      callback && callback(false, result?.data?.message || 'Error');
    }
  } catch (error) {
    console.log('error', error);
    callback && callback(false, 'Error');
  }
  dispatch(setLoader(false));
};

export const rejectLanguageRequest = (id, data, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.rejectLanguageRequest(id, data);
    if (result.status >= 200 && result.status < 300) {
      callback && callback(true, result.data.message, result.data.data);
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
      callback && callback(false, result.data.message || 'Validation error');
    } else if (result?.status == 401) {
      dispatch(setError('Unauthorized'));
      dispatch(logout());
      callback && callback(false, 'Unauthorized');
    } else {
      callback && callback(false, result?.data?.message || 'Error');
    }
  } catch (error) {
    console.log('error', error);
    callback && callback(false, 'Error');
  }
  dispatch(setLoader(false));
};

export const { setLanguageRequests, setError, setLoader } = languageRequestSlice.actions;

export default languageRequestSlice.reducer;
export const languageRequestSelector = (state) => state.languageRequest;
